"use strict";
// Generated from ../ExpressionAntlrLexer.g4 by ANTLR 4.6-SNAPSHOT
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const ATNDeserializer_1 = require("antlr4ts/atn/ATNDeserializer");
const Lexer_1 = require("antlr4ts/Lexer");
const LexerATNSimulator_1 = require("antlr4ts/atn/LexerATNSimulator");
const VocabularyImpl_1 = require("antlr4ts/VocabularyImpl");
const Utils = __importStar(require("antlr4ts/misc/Utils"));
class ExpressionAntlrLexer extends Lexer_1.Lexer {
    constructor(input) {
        super(input);
        // tslint:enable:no-trailing-whitespace
        this.ignoreWS = true; // usually we ignore whitespace, but inside stringInterpolation, whitespace is significant
        this._interp = new LexerATNSimulator_1.LexerATNSimulator(ExpressionAntlrLexer._ATN, this);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return ExpressionAntlrLexer.VOCABULARY;
    }
    // @Override
    get grammarFileName() { return "ExpressionAntlrLexer.g4"; }
    // @Override
    get ruleNames() { return ExpressionAntlrLexer.ruleNames; }
    // @Override
    get serializedATN() { return ExpressionAntlrLexer._serializedATN; }
    // @Override
    get modeNames() { return ExpressionAntlrLexer.modeNames; }
    // @Override
    action(_localctx, ruleIndex, actionIndex) {
        switch (ruleIndex) {
            case 3:
                this.STRING_INTERPOLATION_START_action(_localctx, actionIndex);
                break;
            case 36:
                this.STRING_INTERPOLATION_END_action(_localctx, actionIndex);
                break;
        }
    }
    STRING_INTERPOLATION_START_action(_localctx, actionIndex) {
        switch (actionIndex) {
            case 0:
                this.ignoreWS = false;
                break;
        }
    }
    STRING_INTERPOLATION_END_action(_localctx, actionIndex) {
        switch (actionIndex) {
            case 1:
                this.ignoreWS = true;
                break;
        }
    }
    // @Override
    sempred(_localctx, ruleIndex, predIndex) {
        switch (ruleIndex) {
            case 31:
                return this.WHITESPACE_sempred(_localctx, predIndex);
        }
        return true;
    }
    WHITESPACE_sempred(_localctx, predIndex) {
        switch (predIndex) {
            case 0:
                return this.ignoreWS;
        }
        return true;
    }
    static get _ATN() {
        if (!ExpressionAntlrLexer.__ATN) {
            ExpressionAntlrLexer.__ATN = new ATNDeserializer_1.ATNDeserializer().deserialize(Utils.toCharArray(ExpressionAntlrLexer._serializedATN));
        }
        return ExpressionAntlrLexer.__ATN;
    }
}
ExpressionAntlrLexer.STRING_INTERPOLATION_START = 1;
ExpressionAntlrLexer.PLUS = 2;
ExpressionAntlrLexer.SUBSTRACT = 3;
ExpressionAntlrLexer.NON = 4;
ExpressionAntlrLexer.XOR = 5;
ExpressionAntlrLexer.ASTERISK = 6;
ExpressionAntlrLexer.SLASH = 7;
ExpressionAntlrLexer.PERCENT = 8;
ExpressionAntlrLexer.DOUBLE_EQUAL = 9;
ExpressionAntlrLexer.NOT_EQUAL = 10;
ExpressionAntlrLexer.SINGLE_AND = 11;
ExpressionAntlrLexer.DOUBLE_AND = 12;
ExpressionAntlrLexer.DOUBLE_VERTICAL_CYLINDER = 13;
ExpressionAntlrLexer.LESS_THAN = 14;
ExpressionAntlrLexer.MORE_THAN = 15;
ExpressionAntlrLexer.LESS_OR_EQUAl = 16;
ExpressionAntlrLexer.MORE_OR_EQUAL = 17;
ExpressionAntlrLexer.OPEN_BRACKET = 18;
ExpressionAntlrLexer.CLOSE_BRACKET = 19;
ExpressionAntlrLexer.DOT = 20;
ExpressionAntlrLexer.OPEN_SQUARE_BRACKET = 21;
ExpressionAntlrLexer.CLOSE_SQUARE_BRACKET = 22;
ExpressionAntlrLexer.OPEN_CURLY_BRACKET = 23;
ExpressionAntlrLexer.CLOSE_CURLY_BRACKET = 24;
ExpressionAntlrLexer.COMMA = 25;
ExpressionAntlrLexer.COLON = 26;
ExpressionAntlrLexer.DOLLAR = 27;
ExpressionAntlrLexer.NUMBER = 28;
ExpressionAntlrLexer.WHITESPACE = 29;
ExpressionAntlrLexer.IDENTIFIER = 30;
ExpressionAntlrLexer.NEWLINE = 31;
ExpressionAntlrLexer.STRING = 32;
ExpressionAntlrLexer.INVALID_TOKEN_DEFAULT_MODE = 33;
ExpressionAntlrLexer.TEMPLATE = 34;
ExpressionAntlrLexer.ESCAPE_CHARACTER = 35;
ExpressionAntlrLexer.TEXT_CONTENT = 36;
ExpressionAntlrLexer.STRING_INTERPOLATION_MODE = 1;
// tslint:disable:no-trailing-whitespace
ExpressionAntlrLexer.modeNames = [
    "DEFAULT_MODE", "STRING_INTERPOLATION_MODE",
];
ExpressionAntlrLexer.ruleNames = [
    "LETTER", "DIGIT", "OBJECT_DEFINITION", "STRING_INTERPOLATION_START",
    "PLUS", "SUBSTRACT", "NON", "XOR", "ASTERISK", "SLASH", "PERCENT", "DOUBLE_EQUAL",
    "NOT_EQUAL", "SINGLE_AND", "DOUBLE_AND", "DOUBLE_VERTICAL_CYLINDER", "LESS_THAN",
    "MORE_THAN", "LESS_OR_EQUAl", "MORE_OR_EQUAL", "OPEN_BRACKET", "CLOSE_BRACKET",
    "DOT", "OPEN_SQUARE_BRACKET", "CLOSE_SQUARE_BRACKET", "OPEN_CURLY_BRACKET",
    "CLOSE_CURLY_BRACKET", "COMMA", "COLON", "DOLLAR", "NUMBER", "WHITESPACE",
    "IDENTIFIER", "NEWLINE", "STRING", "INVALID_TOKEN_DEFAULT_MODE", "STRING_INTERPOLATION_END",
    "TEMPLATE", "ESCAPE_CHARACTER", "TEXT_CONTENT",
];
ExpressionAntlrLexer._LITERAL_NAMES = [
    undefined, undefined, "'+'", "'-'", "'!'", "'^'", "'*'", "'/'", "'%'",
    "'=='", undefined, "'&'", "'&&'", "'||'", "'<'", "'>'", "'<='", "'>='",
    "'('", "')'", "'.'", "'['", "']'", "'{'", "'}'", "','", "':'", "'$'",
];
ExpressionAntlrLexer._SYMBOLIC_NAMES = [
    undefined, "STRING_INTERPOLATION_START", "PLUS", "SUBSTRACT", "NON", "XOR",
    "ASTERISK", "SLASH", "PERCENT", "DOUBLE_EQUAL", "NOT_EQUAL", "SINGLE_AND",
    "DOUBLE_AND", "DOUBLE_VERTICAL_CYLINDER", "LESS_THAN", "MORE_THAN", "LESS_OR_EQUAl",
    "MORE_OR_EQUAL", "OPEN_BRACKET", "CLOSE_BRACKET", "DOT", "OPEN_SQUARE_BRACKET",
    "CLOSE_SQUARE_BRACKET", "OPEN_CURLY_BRACKET", "CLOSE_CURLY_BRACKET", "COMMA",
    "COLON", "DOLLAR", "NUMBER", "WHITESPACE", "IDENTIFIER", "NEWLINE", "STRING",
    "INVALID_TOKEN_DEFAULT_MODE", "TEMPLATE", "ESCAPE_CHARACTER", "TEXT_CONTENT",
];
ExpressionAntlrLexer.VOCABULARY = new VocabularyImpl_1.VocabularyImpl(ExpressionAntlrLexer._LITERAL_NAMES, ExpressionAntlrLexer._SYMBOLIC_NAMES, []);
ExpressionAntlrLexer._serializedATN = "\x03\uAF6F\u8320\u479D\uB75C\u4880\u1605\u191C\uAB37\x02&\u0106\b\x01" +
    "\b\x01\x04\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06" +
    "\t\x06\x04\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f" +
    "\x04\r\t\r\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04" +
    "\x12\t\x12\x04\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04" +
    "\x17\t\x17\x04\x18\t\x18\x04\x19\t\x19\x04\x1A\t\x1A\x04\x1B\t\x1B\x04" +
    "\x1C\t\x1C\x04\x1D\t\x1D\x04\x1E\t\x1E\x04\x1F\t\x1F\x04 \t \x04!\t!\x04" +
    "\"\t\"\x04#\t#\x04$\t$\x04%\t%\x04&\t&\x04\'\t\'\x04(\t(\x04)\t)\x03\x02" +
    "\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x03\x04\x05\x04]\n\x04" +
    "\x03\x04\x03\x04\x03\x04\x03\x04\x06\x04c\n\x04\r\x04\x0E\x04d\x07\x04" +
    "g\n\x04\f\x04\x0E\x04j\v\x04\x03\x04\x03\x04\x03\x05\x03\x05\x03\x05\x03" +
    "\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\b\x03\b\x03\t\x03\t\x03" +
    "\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0E\x03\x0E\x03" +
    "\x0E\x03\x0E\x05\x0E\x88\n\x0E\x03\x0F\x03\x0F\x03\x10\x03\x10\x03\x10" +
    "\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x13\x03\x13\x03\x14\x03\x14" +
    "\x03\x14\x03\x15\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x18" +
    "\x03\x18\x03\x19\x03\x19\x03\x1A\x03\x1A\x03\x1B\x03\x1B\x03\x1C\x03\x1C" +
    "\x03\x1D\x03\x1D\x03\x1E\x03\x1E\x03\x1F\x03\x1F\x03 \x06 \xB1\n \r \x0E" +
    " \xB2\x03 \x03 \x06 \xB7\n \r \x0E \xB8\x05 \xBB\n \x03!\x03!\x03!\x03" +
    "!\x03!\x03\"\x03\"\x03\"\x03\"\x03\"\x05\"\xC7\n\"\x03\"\x03\"\x03\"\x07" +
    "\"\xCC\n\"\f\"\x0E\"\xCF\v\"\x03#\x05#\xD2\n#\x03#\x03#\x03#\x03#\x03" +
    "$\x03$\x03$\x03$\x07$\xDC\n$\f$\x0E$\xDF\v$\x03$\x03$\x03$\x03$\x03$\x07" +
    "$\xE6\n$\f$\x0E$\xE9\v$\x03$\x05$\xEC\n$\x03%\x03%\x03&\x03&\x03&\x03" +
    "&\x03&\x03&\x03\'\x03\'\x03\'\x03\'\x03\'\x06\'\xFB\n\'\r\'\x0E\'\xFC" +
    "\x03\'\x03\'\x03(\x03(\x05(\u0103\n(\x03)\x03)\x04\xDD\xE7\x02\x02*\x04" +
    "\x02\x02\x06\x02\x02\b\x02\x02\n\x02\x03\f\x02\x04\x0E\x02\x05\x10\x02" +
    "\x06\x12\x02\x07\x14\x02\b\x16\x02\t\x18\x02\n\x1A\x02\v\x1C\x02\f\x1E" +
    "\x02\r \x02\x0E\"\x02\x0F$\x02\x10&\x02\x11(\x02\x12*\x02\x13,\x02\x14" +
    ".\x02\x150\x02\x162\x02\x174\x02\x186\x02\x198\x02\x1A:\x02\x1B<\x02\x1C" +
    ">\x02\x1D@\x02\x1EB\x02\x1FD\x02 F\x02!H\x02\"J\x02#L\x02\x02N\x02$P\x02" +
    "%R\x02&\x04\x02\x03\f\x04\x02C\\c|\x03\x022;\t\x02\f\f\x0F\x0F$$))bb}" +
    "}\x7F\x7F\x06\x02\v\v\"\"\xA2\xA2\uFF01\uFF01\x05\x02%%BBaa\x04\x02))" +
    "^^\x03\x02))\x04\x02$$^^\x03\x02$$\x04\x02\f\f\x0F\x0F\u011B\x02\n\x03" +
    "\x02\x02\x02\x02\f\x03\x02\x02\x02\x02\x0E\x03\x02\x02\x02\x02\x10\x03" +
    "\x02\x02\x02\x02\x12\x03\x02\x02\x02\x02\x14\x03\x02\x02\x02\x02\x16\x03" +
    "\x02\x02\x02\x02\x18\x03\x02\x02\x02\x02\x1A\x03\x02\x02\x02\x02\x1C\x03" +
    "\x02\x02\x02\x02\x1E\x03\x02\x02\x02\x02 \x03\x02\x02\x02\x02\"\x03\x02" +
    "\x02\x02\x02$\x03\x02\x02\x02\x02&\x03\x02\x02\x02\x02(\x03\x02\x02\x02" +
    "\x02*\x03\x02\x02\x02\x02,\x03\x02\x02\x02\x02.\x03\x02\x02\x02\x020\x03" +
    "\x02\x02\x02\x022\x03\x02\x02\x02\x024\x03\x02\x02\x02\x026\x03\x02\x02" +
    "\x02\x028\x03\x02\x02\x02\x02:\x03\x02\x02\x02\x02<\x03\x02\x02\x02\x02" +
    ">\x03\x02\x02\x02\x02@\x03\x02\x02\x02\x02B\x03\x02\x02\x02\x02D\x03\x02" +
    "\x02\x02\x02F\x03\x02\x02\x02\x02H\x03\x02\x02\x02\x02J\x03\x02\x02\x02" +
    "\x03L\x03\x02\x02\x02\x03N\x03\x02\x02\x02\x03P\x03\x02\x02\x02\x03R\x03" +
    "\x02\x02\x02\x04T\x03\x02\x02\x02\x06V\x03\x02\x02\x02\bX\x03\x02\x02" +
    "\x02\nm\x03\x02\x02\x02\fr\x03\x02\x02\x02\x0Et\x03\x02\x02\x02\x10v\x03" +
    "\x02\x02\x02\x12x\x03\x02\x02\x02\x14z\x03\x02\x02\x02\x16|\x03\x02\x02" +
    "\x02\x18~\x03\x02\x02\x02\x1A\x80\x03\x02\x02\x02\x1C\x87\x03\x02\x02" +
    "\x02\x1E\x89\x03\x02\x02\x02 \x8B\x03\x02\x02\x02\"\x8E\x03\x02\x02\x02" +
    "$\x91\x03\x02\x02\x02&\x93\x03\x02\x02\x02(\x95\x03\x02\x02\x02*\x98\x03" +
    "\x02\x02\x02,\x9B\x03\x02\x02\x02.\x9D\x03\x02\x02\x020\x9F\x03\x02\x02" +
    "\x022\xA1\x03\x02\x02\x024\xA3\x03\x02\x02\x026\xA5\x03\x02\x02\x028\xA7" +
    "\x03\x02\x02\x02:\xA9\x03\x02\x02\x02<\xAB\x03\x02\x02\x02>\xAD\x03\x02" +
    "\x02\x02@\xB0\x03\x02\x02\x02B\xBC\x03\x02\x02\x02D\xC6\x03\x02\x02\x02" +
    "F\xD1\x03\x02\x02\x02H\xEB\x03\x02\x02\x02J\xED\x03\x02\x02\x02L\xEF\x03" +
    "\x02\x02\x02N\xF5\x03\x02\x02\x02P\u0100\x03\x02\x02\x02R\u0104\x03\x02" +
    "\x02\x02TU\t\x02\x02\x02U\x05\x03\x02\x02\x02VW\t\x03\x02\x02W\x07\x03" +
    "\x02\x02\x02Xh\x07}\x02\x02Yg\x05B!\x02Z]\x05D\"\x02[]\x05H$\x02\\Z\x03" +
    "\x02\x02\x02\\[\x03\x02\x02\x02]^\x03\x02\x02\x02^b\x07<\x02\x02_c\x05" +
    "H$\x02`c\n\x04\x02\x02ac\x05\b\x04\x02b_\x03\x02\x02\x02b`\x03\x02\x02" +
    "\x02ba\x03\x02\x02\x02cd\x03\x02\x02\x02db\x03\x02\x02\x02de\x03\x02\x02" +
    "\x02eg\x03\x02\x02\x02fY\x03\x02\x02\x02f\\\x03\x02\x02\x02gj\x03\x02" +
    "\x02\x02hf\x03\x02\x02\x02hi\x03\x02\x02\x02ik\x03\x02\x02\x02jh\x03\x02" +
    "\x02\x02kl\x07\x7F\x02\x02l\t\x03\x02\x02\x02mn\x07b\x02\x02no\b\x05\x02" +
    "\x02op\x03\x02\x02\x02pq\b\x05\x03\x02q\v\x03\x02\x02\x02rs\x07-\x02\x02" +
    "s\r\x03\x02\x02\x02tu\x07/\x02\x02u\x0F\x03\x02\x02\x02vw\x07#\x02\x02" +
    "w\x11\x03\x02\x02\x02xy\x07`\x02\x02y\x13\x03\x02\x02\x02z{\x07,\x02\x02" +
    "{\x15\x03\x02\x02\x02|}\x071\x02\x02}\x17\x03\x02\x02\x02~\x7F\x07\'\x02" +
    "\x02\x7F\x19\x03\x02\x02\x02\x80\x81\x07?\x02\x02\x81\x82\x07?\x02\x02" +
    "\x82\x1B\x03\x02\x02\x02\x83\x84\x07#\x02\x02\x84\x88\x07?\x02\x02\x85" +
    "\x86\x07>\x02\x02\x86\x88\x07@\x02\x02\x87\x83\x03\x02\x02\x02\x87\x85" +
    "\x03\x02\x02\x02\x88\x1D\x03\x02\x02\x02\x89\x8A\x07(\x02\x02\x8A\x1F" +
    "\x03\x02\x02\x02\x8B\x8C\x07(\x02\x02\x8C\x8D\x07(\x02\x02\x8D!\x03\x02" +
    "\x02\x02\x8E\x8F\x07~\x02\x02\x8F\x90\x07~\x02\x02\x90#\x03\x02\x02\x02" +
    "\x91\x92\x07>\x02\x02\x92%\x03\x02\x02\x02\x93\x94\x07@\x02\x02\x94\'" +
    "\x03\x02\x02\x02\x95\x96\x07>\x02\x02\x96\x97\x07?\x02\x02\x97)\x03\x02" +
    "\x02\x02\x98\x99\x07@\x02\x02\x99\x9A\x07?\x02\x02\x9A+\x03\x02\x02\x02" +
    "\x9B\x9C\x07*\x02\x02\x9C-\x03\x02\x02\x02\x9D\x9E\x07+\x02\x02\x9E/\x03" +
    "\x02\x02\x02\x9F\xA0\x070\x02\x02\xA01\x03\x02\x02\x02\xA1\xA2\x07]\x02" +
    "\x02\xA23\x03\x02\x02\x02\xA3\xA4\x07_\x02\x02\xA45\x03\x02\x02\x02\xA5" +
    "\xA6\x07}\x02\x02\xA67\x03\x02\x02\x02\xA7\xA8\x07\x7F\x02\x02\xA89\x03" +
    "\x02\x02\x02\xA9\xAA\x07.\x02\x02\xAA;\x03\x02\x02\x02\xAB\xAC\x07<\x02" +
    "\x02\xAC=\x03\x02\x02\x02\xAD\xAE\x07&\x02\x02\xAE?\x03\x02\x02\x02\xAF" +
    "\xB1\x05\x06\x03\x02\xB0\xAF\x03\x02\x02\x02\xB1\xB2\x03\x02\x02\x02\xB2" +
    "\xB0\x03\x02\x02\x02\xB2\xB3\x03\x02\x02\x02\xB3\xBA\x03\x02\x02\x02\xB4" +
    "\xB6\x070\x02\x02\xB5\xB7\x05\x06\x03\x02\xB6\xB5\x03\x02\x02\x02\xB7" +
    "\xB8\x03\x02\x02\x02\xB8\xB6\x03\x02\x02\x02\xB8\xB9\x03\x02\x02\x02\xB9" +
    "\xBB\x03\x02\x02\x02\xBA\xB4\x03\x02\x02\x02\xBA\xBB\x03\x02\x02\x02\xBB" +
    "A\x03\x02\x02\x02\xBC\xBD\t\x05\x02\x02\xBD\xBE\x06!\x02\x02\xBE\xBF\x03" +
    "\x02\x02\x02\xBF\xC0\b!\x04\x02\xC0C\x03\x02\x02\x02\xC1\xC7\x05\x04\x02" +
    "\x02\xC2\xC7\t\x06\x02\x02\xC3\xC4\x07B\x02\x02\xC4\xC7\x07B\x02\x02\xC5" +
    "\xC7\x04&\'\x02\xC6\xC1\x03\x02\x02\x02\xC6\xC2\x03\x02\x02\x02\xC6\xC3" +
    "\x03\x02\x02\x02\xC6\xC5\x03\x02\x02\x02\xC7\xCD\x03\x02\x02\x02\xC8\xCC" +
    "\x05\x04\x02\x02\xC9\xCC\x05\x06\x03\x02\xCA\xCC\x07a\x02\x02\xCB\xC8" +
    "\x03\x02\x02\x02\xCB\xC9\x03\x02\x02\x02\xCB\xCA\x03\x02\x02\x02\xCC\xCF" +
    "\x03\x02\x02\x02\xCD\xCB\x03\x02\x02\x02\xCD\xCE\x03\x02\x02\x02\xCEE" +
    "\x03\x02\x02\x02\xCF\xCD\x03\x02\x02\x02\xD0\xD2\x07\x0F\x02\x02\xD1\xD0" +
    "\x03\x02\x02\x02\xD1\xD2\x03\x02\x02\x02\xD2\xD3\x03\x02\x02\x02\xD3\xD4" +
    "\x07\f\x02\x02\xD4\xD5\x03\x02\x02\x02\xD5\xD6\b#\x04\x02\xD6G\x03\x02" +
    "\x02\x02\xD7\xDD\x07)\x02\x02\xD8\xD9\x07^\x02\x02\xD9\xDC\t\x07\x02\x02" +
    "\xDA\xDC\n\b\x02\x02\xDB\xD8\x03\x02\x02\x02\xDB\xDA\x03\x02\x02\x02\xDC" +
    "\xDF\x03\x02\x02\x02\xDD\xDE\x03\x02\x02\x02\xDD\xDB\x03\x02\x02\x02\xDE" +
    "\xE0\x03\x02\x02\x02\xDF\xDD\x03\x02\x02\x02\xE0\xEC\x07)\x02\x02\xE1" +
    "\xE7\x07$\x02\x02\xE2\xE3\x07^\x02\x02\xE3\xE6\t\t\x02\x02\xE4\xE6\n\n" +
    "\x02\x02\xE5\xE2\x03\x02\x02\x02\xE5\xE4\x03\x02\x02\x02\xE6\xE9\x03\x02" +
    "\x02\x02\xE7\xE8\x03\x02\x02\x02\xE7\xE5\x03\x02\x02\x02\xE8\xEA\x03\x02" +
    "\x02\x02\xE9\xE7\x03\x02\x02\x02\xEA\xEC\x07$\x02\x02\xEB\xD7\x03\x02" +
    "\x02\x02\xEB\xE1\x03\x02\x02\x02\xECI\x03\x02\x02\x02\xED\xEE\v\x02\x02" +
    "\x02\xEEK\x03\x02\x02\x02\xEF\xF0\x07b\x02\x02\xF0\xF1\b&\x05\x02\xF1" +
    "\xF2\x03\x02\x02\x02\xF2\xF3\b&\x06\x02\xF3\xF4\b&\x07\x02\xF4M\x03\x02" +
    "\x02\x02\xF5\xF6\x07&\x02\x02\xF6\xFA\x07}\x02\x02\xF7\xFB\x05H$\x02\xF8" +
    "\xFB\x05\b\x04\x02\xF9\xFB\n\x04\x02\x02\xFA\xF7\x03\x02\x02\x02\xFA\xF8" +
    "\x03\x02\x02\x02\xFA\xF9\x03\x02\x02\x02\xFB\xFC\x03\x02\x02\x02\xFC\xFA" +
    "\x03\x02\x02\x02\xFC\xFD\x03\x02\x02\x02\xFD\xFE\x03\x02\x02\x02\xFE\xFF" +
    "\x07\x7F\x02\x02\xFFO\x03\x02\x02\x02\u0100\u0102\x07^\x02\x02\u0101\u0103" +
    "\n\v\x02\x02\u0102\u0101\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103" +
    "Q\x03\x02\x02\x02\u0104\u0105\n\v\x02\x02\u0105S\x03\x02\x02\x02\x19\x02" +
    "\x03\\bdfh\x87\xB2\xB8\xBA\xC6\xCB\xCD\xD1\xDB\xDD\xE5\xE7\xEB\xFA\xFC" +
    "\u0102\b\x03\x05\x02\x07\x03\x02\b\x02\x02\x03&\x03\t\x03\x02\x06\x02" +
    "\x02";
exports.ExpressionAntlrLexer = ExpressionAntlrLexer;
//# sourceMappingURL=ExpressionAntlrLexer.js.map